/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ListCredential } from './ListCredential';
import { ListFile } from './ListFile';
import { ListPresentation } from './ListPresentation';

export const DidCommMessage: core.serialization.ObjectSchema<serializers.DidCommMessage.Raw, Truvity.DidCommMessage> =
    core.serialization.object({
        credentials: ListCredential,
        files: ListFile,
        from: core.serialization.string(),
        presentations: ListPresentation,
        to: core.serialization.string(),
    });

export declare namespace DidCommMessage {
    export interface Raw {
        credentials: ListCredential.Raw;
        files: ListFile.Raw;
        from: string;
        presentations: ListPresentation.Raw;
        to: string;
    }
}
